import { db } from './../config/firebase.config';
import { Injectable, NgZone } from '@angular/core';
import * as auth from 'firebase/auth';
import { User } from './user';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/compat/firestore';
import {
  Auth,
  getAuth,
  RecaptchaVerifier,
  sendSignInLinkToEmail,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth';
import { collection, getDocs } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { AlertController } from '@ionic/angular';

//const database = getDatabase();

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userData: any;
  confirmationResult: any;
  credentialData: any;
  info: any;
  details: User;
  /* userDetailsFetched: User ={
    uid: '',
    email: '',
    displayName: ''
  }; */

  constructor(
    public afStore: AngularFirestore,
    public ngFireAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    private alertController: AlertController
  ) {
    /*
    this.ngFireAuth.authState.subscribe((user) => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        console.log(
          'Auth Service constructor setting value to user in local storage:',
          JSON.parse(localStorage.getItem('user'))
        );
      }  else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    }); */
  }
  // Login in with email/password
  async signIn(email, password) {
    //  console.log('Email & password at login:', email, password);
    const auth1 = getAuth();
    signInWithEmailAndPassword(auth1, email, password)
      .then(async (userCredential) => {
        // Signed in
        this.userData = userCredential.user;

        //this.credentialData = userCredential.user.emailVerified;
        localStorage.setItem('user', JSON.stringify(this.userData));
        /* localStorage.setItem(
          'emailVerified',
          JSON.stringify(userCredential.user.emailVerified)
        ); */
        if (userCredential.user.emailVerified) {
          console.log('LOGGED INNN');
          this.ngZone.run(async () => {
            await this.fetchUserDetailsFromDB(email);
          });
          this.info = JSON.parse(localStorage.getItem('userDetails'));
          this.router.navigate(['app/home'], { state: this.info });
        } else {
          const alert = await this.alertController.create({
            message: 'Email not verified, please verify and try again!',
            buttons: ['OK'],
            cssClass: 'alert',
          });
          await alert.present();
          await alert.onDidDismiss();
          //window.alert('Email not Verified');
          this.signOut();
        }
      })
      .catch(async (error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const alert = await this.alertController.create({
          message: 'Error while trying to login, please try again!',
          buttons: ['OK'],
          cssClass: 'alert',
        });
        await alert.present();
        await alert.onDidDismiss();
        console.log('Error while trying to login: ' + errorMessage);
        return error;
      });

    // return this.ngFireAuth.signInWithEmailAndPassword(email, password);
  }

  // Register user with email and password
  registerUser(email, password) {
    return this.ngFireAuth.createUserWithEmailAndPassword(email, password);
  }

  // Email verification when new user register
  sendVerificationMail() {
    return this.ngFireAuth.currentUser.then((user) =>
      user.sendEmailVerification().then(
        async () => {
          const alert = await this.alertController.create({
            message:
              'To complete your account verification, click on the link that has been sent to your email and proceed to log in.',
            buttons: ['OK'],
            cssClass: 'alert',
          });
          await alert.present();
          await alert.onDidDismiss();
          /*  window.alert(
            'Please verify the verification email sent to you and then login'
          ); */
          this.router.navigate(['login']);
        },
        async (error) => {
          const alert = await this.alertController.create({
            message: 'Unable to send verification email, please try again.',
            buttons: ['OK'],
            cssClass: 'alert',
          });
          await alert.present();
          await alert.onDidDismiss();
          // window.alert('Unable to send verification email, please try again');
          this.router.navigate(['login']);
        }
      )
    );
  }

  // Recover password
  passwordRecover(passwordResetEmail) {
    return this.ngFireAuth
      .sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        /*  window.alert(
          'Password reset email has been sent, please check your inbox.'
        ); */
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // Returns true when user is looged in and email is verified
  isLoggedIn(): boolean {
    console.log('Inside isLoggedIn()');
    const user = JSON.parse(localStorage.getItem('user'));
    const link = new URL(window.location.href);
    const email = link.searchParams.get('email');

    if (email !== null) {
      // console.log('Email fetched from URL : ', email);
      if (email !== undefined) {
        const status = this.checkIfLoginFromEmailLink();
        if (status) {
          //console.log('Login from Email retured true');
          return true;
        } else {
          return false;
        }
      }
    } else {
      return user !== null && user.emailVerified !== false ? true : false;
    }
  }
  // Returns true when user's email is verified
  isEmailVerified(): boolean {
    /* const user = JSON.parse(localStorage.getItem('user'));
    console.log('Status of Email Verified:', localStorage.getItem('user'));
    return user.emailVerified !== false ? true : false; */

    const status: boolean = JSON.parse(
      localStorage.getItem('emailVerified')
    ) as boolean;
    console.log('Status of Email Verified:', status);
    return status;
  }
  // Sign in with Gmail
  googleAuth() {
    return this.authLogin(new auth.GoogleAuthProvider());
  }

  // Auth providers
  authLogin(provider) {
    return this.ngFireAuth
      .signInWithPopup(provider)
      .then((result) => {
        this.ngZone.run(() => {
          //const val = new Object(result);
          this.setUserDataWhenGooglelogin(result.user);
          /* const navigateData: NavigationExtras = {
            state: {
              user: result.user,
            },
          }; */
          this.router.navigate(['app/home'], { queryParams: result.user });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /* Store user in localStorage */
  setUserDataWhenGooglelogin(user) {
    const userRef: AngularFirestoreDocument<any> = this.afStore.doc(
      `users/${user.uid}`
    );
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      //photoURL: user.photoURL,
      // emailVerified: user.emailVerified,
    };
    //console.log('------insert new USER DATA as : ', userData);
    return userRef.set(userData, {
      merge: true,
    });
  }

  /* Method to update User Information in the Firestore Database */
  updateUserData(userInfo: User) {
    const userRef: AngularFirestoreDocument<any> = this.afStore.doc(
      `users/${userInfo.email}`
    );

    /* Successfully Updated User Information */
    return userRef.set(userInfo, {
      merge: true,
    });
  }

  async tempFuctofetchlistofEmails(userData: User) {
    const list = [];
    //  const oldFriends = this.userData.friends;
    console.log('Userrrrrr :::: ', userData);
    const usrRef: AngularFirestoreDocument<any> = this.afStore.doc(
      `users/${userData.email}`
    );
    const querySnapshot = await getDocs(collection(db, 'users'));
    querySnapshot.forEach(async (doc) => {
      if (doc.get('email') !== userData.email) {
        if (userData.friends.length > 0) {
          userData.friends.forEach(async (element) => {
            if (element.email !== doc.get('email')) {
              const link = await this.getPhoto(doc.get('email'));
              //     console.log('linkkkkk : ', link);
              //const em: string = doc.get('email');
              const data = {
                name: doc.get('displayName'),
                email: doc.get('email'),
                picture: link,
              };
              list.push(data);
            }
          });
        } else {
          const link = await this.getPhoto(doc.get('email'));
          //   console.log('linkkkkk : ', link);
          //const em: string = doc.get('email');
          const data = {
            name: doc.get('displayName'),
            email: doc.get('email'),
            picture: link,
          };
          list.push(data);
        }
      }
    });
    //console.log('Emails found: ', list);
    return list;
  }

  async getPhoto(email) {
    const storage = getStorage();
    //  const pathReference = ref(storage, this.userData.email);
    let link;
    await getDownloadURL(ref(storage, email))
      .then((link1) => {
        // `url` is the download URL for 'images/stars.jpg'

        // This can be downloaded directly:
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
        };
        xhr.open('GET', link1);
        xhr.send();
        // console.log('------------LINK :', link1);
        link = link1;
      })
      .catch((error) => {
        // Handle any errors
      });
    return link;
  }
  async findEmail(email: string) {
    let status = false;
    const querySnapshot = await getDocs(collection(db, 'users'));
    querySnapshot.forEach((doc) => {
      if (doc.get('email') === email) {
        status = true;
      }
    });
    return status;
  }

  /*  Method to fetch user information from the database */
  async fetchUserDetailsFromDB(email: string) {
    const querySnapshot = await getDocs(collection(db, 'users'));
    querySnapshot.forEach((doc) => {
      if (doc.get('email') === email) {
        const logins: User = {
          uid: doc.get('uid'), //Unique ID assigned to each user
          email: doc.get('email'),
          displayName: doc.get('displayName'),
          mobile: doc.get('mobile'),
          gender: doc.get('gender'),
          dob: doc.get('dob'),
          registrationDeviceInfo: doc.get('registrationDeviceInfo'),
          registrationIP: doc.get('registrationIP'),
          registrationGeoLocation: doc.get('registrationGeoLocation'),
          loginSuccesses: doc.get('loginSuccesses'),
          securityQuestAns: doc.get('securityQuestAns'),
          posts: doc.get('posts'),
          currentCity: doc.get('currentCity'),
          homeCity: doc.get('homeCity'),
          friends: doc.get('friends'),
          reAuthTriggeredDetails: doc.get('reAuthTriggeredDetails'),
        };
        // Storing the logged in user details in device local storeage
        this.setUserDetailsToLocalStorage(logins);
      }
    });
  }

  // Sign-out
  signOut() {
    return this.ngFireAuth.signOut().then(() => {
      localStorage.clear();
      this.router.navigate(['login']);
    });
  }

  async sendEmailWithLink(email: string) {
    try {
      let status;

      const auth1 = getAuth();
      const link = new URL(window.location.href);
      let urlLink;
      //    'http://localhost:8100/app/home/?email=' + email,
      if (link.hostname === 'localhost') {
        urlLink = 'http://localhost:8100/app/home/?email=' + email;
      } else {
        urlLink =
          'https://socialnetworkforfriends.firebaseapp.com/app/home/?email=' +
          email;
      }
      //console.log('!!!!!!! sendEmailWithLink ::: ', urlLink);

      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be in the authorized domains list in the Firebase Console.
        url: urlLink,
        // This must be true.
        handleCodeInApp: true,
      };
      return sendSignInLinkToEmail(auth1, email, actionCodeSettings)
        .then(async () => {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          // localStorage.setItem('emailForSignIn', email);
          const alert = await this.alertController.create({
            message: 'Email sent with link to sign in',
            buttons: ['OK'],
            cssClass: 'alert',
          });
          await alert.present();
          await alert.onDidDismiss();
          // window.alert('Email sent with Link to Sign In');
          status = true;
          return status;
          // ...
        })
        .catch(async (error) => {
          //const errorCode = error.code;
          //const errorMessage = error.message;
          // ...
          status = false;
          const alert = await this.alertController.create({
            message: 'Error in sending email, please try again!',
            buttons: ['OK'],
            cssClass: 'alert',
          });
          await alert.present();
          await alert.onDidDismiss();
          console.log('Error in sending Email :', error.message);
          return status;
        });
    } catch (error) {
      const alert = await this.alertController.create({
        message: 'Error in sending email, please try again!',
        buttons: ['OK'],
        cssClass: 'alert',
      });
      await alert.present();
      await alert.onDidDismiss();
      console.log('======== Error in sendEmailWithLink()', error);
      return false;
    }
  }

  getLoginAttemptsFromLocalStorage() {
    const attempts = localStorage.getItem('loginAttempts');
    const obj: number = JSON.parse(attempts);
    return obj;
  }
  setUserDetailsToLocalStorage(userDetailsFetched: User) {
    localStorage.setItem('userDetails', JSON.stringify(userDetailsFetched));
  }

  getUserDetailsFromLocalStorage() {
    const details = localStorage.getItem('userDetails');
    const obj: User = JSON.parse(details);

    return obj;
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  async sendCodeonPhone(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    auth: Auth,
    phoneNumber: string,
    appVerifier: RecaptchaVerifier
  ) {
    let sentCode: boolean;
    console.log('Registered Mobile Number', phoneNumber);
    // throw new Error('Method not implemented.');
    await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        // window.alert('Confirmation Result: ' + confirmationResult);
        // window.alert('SMS successfully sent');
        console.log('Confirmation Result :', confirmationResult);
        sentCode = true;
        this.confirmationResult = confirmationResult;

        // ...
      })
      .catch(async (error) => {
        // Error; SMS not sent
        // ...
        console.log('error :', error);
        // window.alert('SMS not sent');
        const alert = await this.alertController.create({
          message: 'Unable to send SMS, please try again!',
          buttons: ['OK'],
          cssClass: 'alert',
        });
        await alert.present();
        await alert.onDidDismiss();
        sentCode = false;
      });
    return sentCode;
  }

  async verifyMobileCode(code: string, details: any) {
    let status;
    await this.confirmationResult
      .confirm(code)
      .then(async (result) => {
        // User signed in successfully.
        console.log('Mobile Code verified: ', result);
        const user = result.user;
        status = true;
        //await this.signIn(details.email, details.password);
        // ...
      })
      .catch(async (error) => {
        // User couldn't sign in (bad verification code?)
        // ...
        //window.alert('Verify Confirmation Code failed :' + error);
        const alert = await this.alertController.create({
          message: 'Unable to verify with the SMS code, please try again!',
          buttons: ['OK'],
          cssClass: 'alert',
        });
        await alert.present();
        await alert.onDidDismiss();
        status = false;
        //this.router.navigate(['login']);
      });
    return status;
  }
  generateOTP() {
    return Math.floor(100000 + Math.random() * 900000).toString();
  }

  /* async sendCodeonEmail(email: string) {
     console.log('Registered Email', email);
    throw new Error('Method not implemented.');
    const otp = this.generateOTP();
     console.log('OTP Generated', otp);
    const functions = func;
    let cloudFunc: func.Functions;

    const sendEmail = functions.httpsCallable(cloudFunc, 'sendEmail');
    //  console.log('Calling Cloud Function sendEmail with OTP Obj : ', sendEmail);
    await sendEmail({
      to: email,
      subject: 'Your One-Time Password',
      text: 'Your OTP is: ${otp}',
      html: '<p> Your OTP is  ${otp} to sign in to your Streaming Website </p>',
    })
      .then((result: any) => {
        console.log(result.data);
      })
      .catch((error: any) => {
        console.error(error);
      });
  }   */

  async checkIfMobileRegistered(mobile: string, email: string) {
    //console.log('Inside checkIfMobileRegistered func ', mobile, email);
    let found: boolean;
    await this.fetchUserDetailsFromDB(email);
    const det: User = this.getUserDetailsFromLocalStorage();
    //console.log('Mobile inside DB :: ', det.mobile);
    if (det !== undefined && det.mobile === mobile) {
      //console.log('Mobile Number is registered');
      found = true;
    } else {
      //console.log('Mobile Number is NOT registered');
      found = false;
    }
    return found;
  }
  async checkIfEmailRegistered(email: string) {
    //console.log('Checking if Email is Registered', email);
    //let found: boolean;
    await this.fetchUserDetailsFromDB(email);
    const obj: User = this.getUserDetailsFromLocalStorage();
    if (obj === undefined) {
      const alert = await this.alertController.create({
        message: 'Email is not registered, please try again!',
        buttons: ['OK'],
        cssClass: 'alert',
      });
      await alert.present();
      await alert.onDidDismiss();
      // window.alert('Invalid Email');
      return false;
    } else if (obj.email === email) {
      return true;
    }
  }

  async checkIfLoginFromEmailLink() {
    const auth1 = getAuth();
    if (isSignInWithEmailLink(auth1, window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      let email = localStorage.getItem('emailForSignIn');
      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt('Please provide your email for confirmation');
      }
      //const actionCode = getParameterByName('oobCode');
      // The client SDK will parse the code from the link for you.
      await signInWithEmailLink(auth1, email, window.location.href)
        .then(async (result) => {
          // Clear email from storage.
          window.localStorage.removeItem('emailForSignIn');
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser

          this.userData = result.user;
          localStorage.setItem('user', JSON.stringify(this.userData));
          localStorage.clear();
          /* console.log(
            'User Details after Login with Email Link',
            this.userData
          ); */
          /* console.log(
            'User Details from DB',
            localStorage.getItem('userDetails')
          ); */
          return true;
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          console.log('Error: ', error.message);
          return false;
        });
    }
  }
}
